import { h, render } from 'preact'

import { Provider } from 'react-redux'
import Button from 'embed/containers/Button'
import Popup from 'embed/containers/Popup'
import TimedOverlay from 'embed/containers/TimedOverlay'
import CartPageNotice from 'embed/containers/CartPageNotice'
import PrepareCartForOffers from 'embed/containers/PrepareCartForOffers'
import { initializeProductForm, getButtonContainer, getCartPageNoticeContainer } from 'embed/helpers'

export const initMakeAnOffer = (store) => {
  const form = initializeProductForm(makeAnOfferData)

  store.dispatch({ type: 'SET_DATA', data: makeAnOfferData })
  const container = getButtonContainer(store.getState().userSettings, form)

  if (container) {
    const oldContainerPresent = container.id == "mf_button"
    render(
      <Provider store={store}>
        <Button oldContainer={oldContainerPresent}/>
      </Provider>,
      container,
      container.lastChild
    );
  }

  if (document.body) {
    var popupDiv = document.createElement('div');
    document.body.appendChild(popupDiv);
    render(<Provider store={store}><Popup /></Provider>, document.body, popupDiv);

    var timedOveralyDiv = document.createElement('div');
    document.body.appendChild(timedOveralyDiv);
    render(<Provider store={store}><TimedOverlay /></Provider>, document.body, timedOveralyDiv);

    var cartPageNoticeContainer = getCartPageNoticeContainer()
    var cartPageNoticeWrapper = document.createElement('div')
    cartPageNoticeContainer.insertBefore(cartPageNoticeWrapper, cartPageNoticeContainer.childNodes[0]);

    if (cartPageNoticeContainer) {
      render(
        <Provider store={store}>
          <CartPageNotice />
        </Provider>,
        cartPageNoticeWrapper
      );
    } else {
      render(<Provider store={store}><CartPageNotice /></Provider>, document.body);
    }

    var prepareCartForOffersDiv = document.createElement('div');
    document.body.appendChild(prepareCartForOffersDiv);
    render(<Provider store={store}><PrepareCartForOffers /></Provider>, document.body, prepareCartForOffersDiv);
  } else {
    console.info('Make an Offer: Document body not found')
  }
}

export const initMFBase = (store) => {
  window.MFBase = {
    init: () => {
      store.dispatch({ type: 'SET_DATA', data: makeAnOfferData });
    },
    getProducts: () => {
      return store.getState().products;
    }
  }
}
